import {FC, ReactElement, useEffect, useState} from 'react';
import styled from 'styled-components';
import {AppState} from '@/state';
import home_tips_bg from '../../assets/images/home_tips_bg.png'
import dayjs from 'dayjs'
import {getScatter} from "utils/client";
import Server from "utils/serviceApi";
import LoadingModal from "components/LoadingModal";
import TipsModal from "components/TipsModal";
import FailModal from "components/FailModal";
import {useTranslation} from "react-i18next";
import FailMessageModal from "components/FailMessageModal";
import {useHistory} from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import CertificationTipsModal from "components/CertificationTipsModal";
import {getUserInfo} from "state/base/reducer";

const Compare: FC = (): ReactElement => {
    const {t} = useTranslation();
    const history = useHistory()
    const dispatch = useDispatch();
    const {account} = useSelector((state: AppState) => state.baseInfo)
    const {
        getCompareInitialize, getCompareCheckData, getTableRowsByRecovery
    } = Server

    const [loadingVal, setLoadingVal] = useState('')
    const [tipsVisible, setTipsVisible] = useState<boolean>(false)
    const [certificationtipsVisible, setCertificationTipsVisible] = useState<boolean>(false)
    const [failedVisible, setFailedVisible] = useState<boolean>(false)
    const [failedMessageVisible, setFailedMessageVisible] = useState<boolean>(false)
    const [failedMsg, setFailedMsg] = useState('')

    useEffect(() => {
        const initData = async () => {
            if (account.name) {
                try {
                    const checkData = await getCompareCheckData({account: account.name,checkerType:'realme'})

                    if (checkData.data) {
                        if (checkData.data.samePerson) {
                            history.push('/compare-success')
                        } else {
                            if (checkData.data.status === 'PENDING') {
                                history.push('/compare-verifying')
                            }
                        }
                    }


                } catch (e) {
                    console.log(e)
                }

            } else {
                dispatch(getUserInfo());
            }
        }
        void initData()

    }, [account.name, getCompareCheckData, dispatch, history])

    const handleSubmit = async () => {

        try {
            setLoadingVal(t('home.Waiting'))
            const scatter: any = getScatter()
            const currentTsVal = dayjs().unix();
            const signatureString = JSON.stringify({
                account: account.name,
                checkerType:'realme',
                ts: currentTsVal,
            });
            let publicKey = account.publicKey;
            const recoveryData = await getTableRowsByRecovery(account.name)
            if (recoveryData.rows.length > 0) {
                publicKey = recoveryData.rows[0].recover_target[1]
            }

            const signData = await scatter.getArbitrarySignature(
                publicKey,
                signatureString,
            );
            const initData = await getCompareInitialize({
                param: {
                    account: account.name,
                    checkerType:'realme',
                    ts: currentTsVal,
                }, signData: signData,
            })

            if (initData.code === 9003) {
                history.push('/success')
            } else if (initData.code === 9005) {
                setLoadingVal('')
                setFailedMsg(t('home.signatureFailed'))
                setFailedMessageVisible(true)
            } else if (initData && initData.data) {
                setLoadingVal('')
                const baseurl = 'https://sg-production-cdn.zoloz.com/page/zoloz-face-fe/index.html'
                const zolozurl = baseurl + "?clientcfg=" + encodeURIComponent(initData.data.clientCfg);
                window.location.href = zolozurl;
            }else{
                setLoadingVal('')
                setFailedVisible(true)
            }

        } catch (e) {
            setLoadingVal('')
            setFailedVisible(true)
            console.log(e)
        }

    }
    const connectWallt = () => {
        dispatch(getUserInfo());
    }
    return (
        <Main>
            <CertificationContent>
                <ConnectTip>
                    <div className='tip_item'>
                        <p><span>1.</span></p>
                        <p style={{flex: '1'}}>{t('home.Compare1')}</p>
                    </div>
                    <div className='tip_item'>
                        <p><span>2.</span></p>
                        <p style={{flex: '1'}}>{t('home.Compare2')}</p>
                    </div>
                    <div className='tip_item'>
                        <p><span>3.</span></p>
                        <p style={{flex: '1'}}>{t('home.Compare3')}</p>
                    </div>
                    <div className='tip_item'>
                        <p><span>4.</span></p>
                        <p style={{flex: '1'}}>{t('home.Compare4')}</p>
                    </div>
                </ConnectTip>
                {account.name ? <CertificationBtn onClick={handleSubmit}>
                    <div>DID {t('home.Compare')}</div>
                </CertificationBtn> : <CertificationBtn onClick={connectWallt}>
                    <div>{t('layout.connect')}</div>
                </CertificationBtn>}
            </CertificationContent>

            {loadingVal && <LoadingModal content={loadingVal}/>}
            {tipsVisible && <TipsModal onClose={() => setTipsVisible(false)}/>}
            {failedVisible && <FailModal onClose={() => setFailedVisible(false)}/>}
            {failedMessageVisible && <FailMessageModal msg={failedMsg} onClose={() => setFailedMessageVisible(false)}/>}
            {certificationtipsVisible && <CertificationTipsModal onClose={() => setCertificationTipsVisible(false)}/>}
        </Main>
    );
};

const Main = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const CertificationContent = styled.div`
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding: 0.81rem 0.16rem 0 0.16rem;
`;

const CertificationBtn = styled.div`
  height: 44px;
  background: linear-gradient(135deg, #49ADFF 0%, #1DEECE 100%);
  box-shadow: 0px 4px 10px 0px rgba(67, 178, 203, 0.2);
  border-radius: 22px;
  text-align: center;
  line-height: 32px;
  margin-top: 0.4rem;
  font-weight: 600;
  color: #FFFFFF;
  padding: 5px 6px;
  width: 90%;

  div {
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.24) 0%, rgba(255, 255, 255, 0) 100%);
    box-shadow: 0px 4px 10px 0px rgba(67, 178, 203, 0.2);
    border-radius: 22px;
  }
`;
const ConnectTip = styled.div`
  position: relative;
  width: 100%;
  padding: 0.16rem 0.14rem;
  font-size: 0.16rem;
  font-family: PingFang SC-Bold, PingFang SC;
  text-align: left;
  margin-top: 0.2rem;
  background: url(${home_tips_bg}) no-repeat center;
  background-size: 100% 100%;
  color: #434347;
  line-height: 0.24rem;

  .tip_item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 0.08rem;
  }

  span {
    color: #08BDC7;
    font-weight: 500;
    margin-right: 0.04rem;
  }
`;
export default Compare;
